import { Text } from "../../components";
import VideoProfile from "../../components/VideoProfile";
import React, { Suspense } from "react";

const userVideoList = [
  {
    financialText: "Financial",
    howToReadText: "How to Read a P&L",
    viewsText: "30K Views",
    timeText: "9:16",
  },
  {
    financialText: "Financial",
    howToReadText: "How to Read a P&L",
    viewsText: "30K Views",
    timeText: "9:16",
  },
  {
    financialText: "Financial",
    howToReadText: "How to Read a P&L",
    viewsText: "30K Views",
    timeText: "9:16",
  },
];

export default function RelatedVideosSection() {
  return (
    <>
      {/* related videos section */}
      <div className="mt-6 flex flex-col gap-4 px-5">
        <div className="container-xs flex">
          <Text
            size="text2xl"
            as="p"
            className="text-[16px] font-normal !text-gray-900_01"
          >
            Related Videos
          </Text>
        </div>
        <div className="mr-[654px] flex gap-3.5 overflow-x-scroll md:mr-0 md:flex-col sm:flex-row">
          <Suspense fallback={<div>Loading feed...</div>}>
            {userVideoList.map((d, index) => (
              <VideoProfile {...d} key={"listuserOne" + index} />
            ))}
          </Suspense>
        </div>
      </div>
    </>
  );
}
